import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import DataGrid from '../../components/common/dataGrid/dataGrid';
import ButtonWithSearch from '../../components/common/buttonWithSearch';
import { commonGetApi, commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import {
  arrageArrayFunc,
  convertToSearchField,
  generateColumnMetadata,
  Feature,
  generateValidObject,
  dateFormat,
} from "../../utils/utils";
import PrimaryHeading from '../../components/common/primaryHeading';
import PrimarySideBar from '../../components/common/sideBar/primarySideBar';
import InputIterator from '../../components/common/inputIterator';
import AddButtonSection from '../../components/common/AddButtonSection';
import { donorFormRender, DonorsTableColumns } from "../../utils/serviceData";
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";
import { SORT_ORDER } from "../../constants/sortOrder";
import { useNavigate } from "react-router-dom";
import AddImageSection from '../../components/common/AddImageSection';
import InputPrimaryComponents from '../../components/common/inputPrimaryComponents';
export default function Donor(props) {
  const {
    control,
    formState: { errors, dirtyFields },
    handleSubmit,
    reset,
    setValue,
    trigger
  } = useForm({});
  const menuLeft = useRef(null);
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState([]);
  const [initLoading, setInitLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [addDonorVisible, setAddDonorVisible] = useState(false);
  const [editDonorVisible, setEditDonorVisible] = useState(false);
  const [editDonorDetails, setEditDonorDetails] = useState({});
  const searchFields = ["first_name", "last_name", "email", "phone_no", "total_collectable_amount"];
  const [formRender, setFormRender] = useState(donorFormRender);
  const [existingDonorNames, setExistingDonorNames] = useState([]);
  const [selected, setSelected] = useState(null);
  const [donorVisible, setDonorVisible] = useState(false);
  const [uploadedImg, setUploadedImg] = useState({});
  const navigate = useNavigate();
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 1,
    sortBy: "user_name",
    sortDir: SORT_ORDER.ASC,
    searchCriteria: convertToSearchField(searchFields, ""),
  });
  const fields = [
    "donor_name",
    "first_name",
    "last_name",
    "email",
    "address",
    "city",
    "district",
    "state",
    "pincode",
    "phone_no",
  ];
  const onRowCountChange = (e) => {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    }));
    init({
      ...navigator,
      page: 1,
      first: 0,
      rows: e?.target?.value,
    });
  };

  function onPageChange(event) {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      first: event?.first,
      page: event.page + 1,
    }));
    init({
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    });
  }

  const onRowClick = (event) => {
    if (Feature?.featureVerify(Feature.listOfFeature.campView)) {
      navigate(`/donor/${event?.data?.donor_id}`);
    }
  };

  const addDonation = async (data) => {
    if (loader) return;
    setLoader(true);
    const amount = {
      donor_id: selected,
      donation_amount: data?.amount,
      donation_date: dateFormat(data?.date),
    };
    let headers = {
      "Content-Type": "application/json",
    };
    await commonPostApi(API_ENDPOINTS.ADD_DONATION, amount, {
      headers,
    })
      .then((data) => {
        if (data?.data?.success) {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.DONOR.DONATION_ADDED);
          setDonorVisible(false);
          init(navigator);
          setLoader(false);
        } else {
          showToast(TOAST_TYPE.ERROR, data?.message);
          setLoader(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const donorbtn = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      onClick: handleSubmit(addDonation),
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: () => {
        reset();
        setDonorVisible(false);
      },
    },
  ];

  const init = async (navigator) => {
    setInitLoading(true);
    let currentObj = {
      query: {
        page: navigator?.page,
        limit: navigator?.rows,
        searchCriteria: navigator?.searchCriteria,
      },
    };

    Promise.all([commonPostApi(API_ENDPOINTS.DONOR_DETAILS, currentObj),
    commonGetApi(API_ENDPOINTS.EXISTING_DONOR)
    ])
      .then(([data, existingRes]) => {
        const donorData = data?.data?.data;
        if (donorData.length === 0) {
          setLoading(false);
        }
        setNavigator((prev) => ({
          ...prev,
          totalRecords: data?.data?.total,
          page: data?.data?.currentPage,
        }));
        setExistingDonorNames(
          (existingRes?.data?.data || [])
            .map((d) => d?.user_name?.toLowerCase()?.trim())
            .filter(Boolean)
        );

        setColumns(
          arrageArrayFunc(
            generateColumnMetadata({
              data: donorData,
              alias: {
                donor_name: "donor",
                phone_no: "phone number",
              },
              defaultColumnsArr: DonorsTableColumns
            }),
            ["donor_name", "email", "phone_no", "total_collectable_amount"]
          )
        );
        setValues(donorData);
        setLoading(false);
        setInitLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSortClick = (event) => {
    setLoading(true);
    const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;
    setNavigator((prev) => ({
      ...prev,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    }));
    init({
      ...navigator,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    });
  };

  const onSubmit = async (data) => {
    if (loader) return;
    setLoader(true);
    if (uploadedImg?.size > 800 * 1024) {
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.VALIDATION.FILE_SIZE_EXCEEDED);
      setLoader(false);
      return;
    }
    let headers = { "Content-Type": "application/json" };
    const addDonor = {
      ...data,
      start_date: dateFormat(data["start_date"]),
      end_date: dateFormat(data["end_date"]),

    }
    let finalData = addDonor;
    if (uploadedImg && uploadedImg.size > 0) {
      finalData = new FormData();
      finalData.append("profile_picture", uploadedImg);
      finalData.append("_payload", JSON.stringify(addDonor));
      headers = {};
    }
    await commonPostApi(API_ENDPOINTS.ADD_DONOR_DETAILS, finalData, {
      headers,
    })
      .then((data) => {
        if (data?.message) {
          showToast(TOAST_TYPE.ERROR, data?.message);
          setLoader(false);
        } else {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.DONOR.ADDED);
          setAddDonorVisible(false);
          init(navigator);
          reset();
          setLoader(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const onEdit = async (data) => {
    if (loader) return;
    setLoader(true);
    let headers = {};
    let validObj = generateValidObject(data);
    const dob = dateFormat(validObj["dob"]);
    validObj = {
      ...validObj,
      dob: dob,
      donor_id: editDonorDetails?.donor_id
    };
    let finaldata = validObj;
    if (uploadedImg && uploadedImg.size && uploadedImg.size > 0) {
      finaldata = new FormData();
      finaldata.append("profile_picture", uploadedImg);
      finaldata.append("_payload", JSON.stringify(validObj));
      headers = {
        "Content-Type": "multipart/form-data",
      };
    } else {
      headers = {
        "Content-Type": "application/json",
      };
    }
    await commonPostApi(
      API_ENDPOINTS.EDIT_DONOR_DETAILS,
      finaldata,
      {
        headers,
      }
    )
      .then((data) => {
        if (data?.message) {
          showToast(TOAST_TYPE.ERROR, data?.message);
          setLoader(false);
        } else {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.DONOR.UPDATED);
          setEditDonorVisible(false);
          init(navigator);
          reset();
          setLoader(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const button = [
    {
      type: "primarySuccessButton",
      label: "Add Donor",
      icon: "pi pi-plus",
      class: "mt-2 ml-2 w-full flex pr-4",
      onClick: () => {
        setAddDonorVisible(true);
        setEditDonorDetails({});
      },
    },
  ];
  const itemRenderer = (item, prop) => (
    <div className="p-menuitem-content">
      {item.label === "Add Donation" &&
        Feature?.featureVerify(Feature.listOfFeature.userAddRole) && (
          <Button
            className="card-button-assign-role"
            label="Add Donation"
            onClick={() => {
              reset();
              setDonorVisible(true);
              setSelected(prop?.props?.itemProp?.donor_id);
              setValue("donor_name", prop?.props?.itemProp?.donor_name);
            }}
          />
        )}
      {item.label === "Edit" &&
        props?.page !== "role" &&
        Feature?.featureVerify(Feature.listOfFeature.userEdit) && (
          <Button
            className="card-button-edit-secound"
            label="Edit"
            onClick={() => {
              setEditDonorVisible(true);
              const imgUrl = prop?.props?.itemProp.profile_picture
                ? `${process.env?.REACT_APP_CURRENT_URL}${API_ENDPOINTS.SEARCH_IMAGE_BY_ID(prop?.props?.itemProp?.donor_id)}`
                : null;
              console.log("imgurl", imgUrl);
              setEditDonorDetails(prop?.props?.itemProp);
              setUploadedImg(imgUrl);

            }}
          />
        )}
    </div>
  );

  const AddDonorbuttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      disabled: Object.keys(dirtyFields).length === 0 || loader,
      onClick: handleSubmit(onSubmit),
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: () => {
        reset();
        setAddDonorVisible(false);
      },
    },
  ];
  const EditDonorbuttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      disabled: Object.keys(dirtyFields).length === 0 || loader,
      onClick: handleSubmit(onEdit),
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: () => {
        setEditDonorVisible(false);
      },
    },
  ];

  function handleSearchChange(value) {
    setNavigator((prev) => ({
      ...prev,
      searchCriteria: convertToSearchField(searchFields, value),
    }));
    init({
      ...navigator,
      searchCriteria: convertToSearchField(searchFields, value),
    });
  }

  useEffect(() => {
    init(navigator);
  }, []);

  useEffect(() => {
    if (editDonorVisible && editDonorDetails) {
      fields.forEach((field) => setValue(field, editDonorDetails[field]));
    }
  }, [editDonorVisible, editDonorDetails]);
  useEffect(() => {
    setFormRender((form) => {
      const passwordForm = donorFormRender.filter(
        (item) => item?.type === "password"
      );
      const filteredForm = form.filter((item) => item?.type !== "password");
      if (editDonorVisible) return filteredForm;
      filteredForm.splice(5, 0, ...passwordForm);
      return filteredForm;
    });
  }, [editDonorVisible, addDonorVisible]);

  useEffect(() => {
    setFormRender((prev) =>
      prev.map((field) => {
        if (field.name === "donor_name") {
          return {
            ...field,
            rules: {
              ...field.rules,
              validate: (value) => {
                if (!value) return true;

                const normalized = value.toLowerCase().trim();

                // allow same username while editing
                if (
                  editDonorVisible &&
                  normalized ===
                  editDonorDetails?.donor_name?.toLowerCase()?.trim()
                ) {
                  return true;
                }

                return existingDonorNames.includes(normalized)
                  ? "Donor name already exists"
                  : true;
              },
            },
          };
        }
        return field;
      })
    );
    if (!editDonorVisible) {
      trigger("donor_name")
    }
  }, [existingDonorNames, editDonorVisible, editDonorDetails, trigger]);

  return (
    <div className="container">
      <PrimaryHeading className={"mt-5 mb-3"} />
      <DataGrid
        header={
          <ButtonWithSearch
            buttons={button}
            backButton={props?.backButton}
            searchHeaderLable={"Donors"}
            searchPlaceHolder={"Search Donors"}
            isSearchEnabled={true}
            isCalenderEnabled={false}
            isButtonEnabledLeft={false}
            isButtonEnabledRight={Feature?.featureVerify(
              Feature.listOfFeature.userAdd
            )}
            loading={initLoading}
            styles={{ gridTemplateColumns: "1fr 400px" }}
            onChange={handleSearchChange}
          />
        }
        onRowClick={onRowClick}
        onSortClick={onSortClick}
        onPageChange={onPageChange}
        onRowCountChange={onRowCountChange}
        isPaginatorEnabled={true}
        navigator={navigator}
        column={columns}
        value={values}
        sortable={true}
        ref={menuLeft}
        loading={loading}
        optionsView={[
          {
            items: [
              {
                label: "Add Donation",
                icon: "pi pi-pencil",
                template: itemRenderer,
              },
              {
                label: "Edit",
                icon: "pi pi-pencil",
                template: itemRenderer,
              },
            ],
          },
        ]}
      />
      {addDonorVisible && (
        <PrimarySideBar
          visible={addDonorVisible}
          onHide={() => {
            reset();
            setAddDonorVisible(false)
          }}
          header={<div className="sideBar-header">Add Donor</div>}
        >
          <AddImageSection showImg={uploadedImg} setImg={setUploadedImg} />
          <InputIterator
            control={control}
            errors={errors}
            formRender={formRender}
            onInputChange={(name) => {
              if (name === "donor_name") {
                trigger("donor_name");
              }
            }}
          />
          <div className="pt-3">
            <AddButtonSection buttons={AddDonorbuttons} />
          </div>
        </PrimarySideBar>
      )}
      {editDonorVisible && (
        <PrimarySideBar
          visible={editDonorVisible}
          onHide={() => {
            reset();
            setEditDonorVisible(false)
          }}
          header={<div className="sideBar-header">Edit Donor</div>}
        >
          <AddImageSection showImg={uploadedImg} setImg={setUploadedImg} />
          <InputIterator
            control={control}
            errors={errors}
            formRender={formRender}
            onInputChange={(name) => {
              if (name === "user_name") {
                trigger("user_name");
              }
            }}
          />
          <div className="pt-3">
            <AddButtonSection buttons={EditDonorbuttons} />
          </div>
        </PrimarySideBar>
      )}
      {donorVisible && (
        <PrimarySideBar
          visible={donorVisible}
          onHide={() => setDonorVisible(false)}
          header={<div className="sideBar-header">Add Donation Amount</div>}
        >
          <InputPrimaryComponents
            control={control}
            type="text"
            label="Donor Name"
            name="donor_name"
            searchIcon
            required
            disabled
          />
          <InputPrimaryComponents
            type="calendar"
            label="Date"
            name="date"
            rules={{
              required: "Date is required",
            }}
            required
            control={control}
            errors={errors}
          />

          <InputPrimaryComponents
            type="currency"
            label="Amount"
            name="amount"
            rules={{
              required: "Amount is required",
              validate: {
                minValue: (value) =>
                  parseInt(value, 10) > 0 || "Payment amount cannot be zero",
              },
            }}
            required
            control={control}
            errors={errors}
          />
          <div className="pt-3">
            <AddButtonSection disabled={loading} buttons={donorbtn} />
          </div>
        </PrimarySideBar>
      )}
    </div>
  );
}
